import { useMemo } from 'react';
import { useDocument } from '@nandorojo/swr-firestore';
import { SettingCollectionPath } from '@typings/collections.enum';
import { PetDefault, getPetLabel } from '@typings/pets/pet.interface';

/**
 * 펫 커스텀 용어 훅
 * - SWR 캐시로 동일 구독 재사용 → prop drilling 불필요
 * - 관리자 설정 페이지에서는 사용하지 않음 (커스텀 용어 미적용)
 */
export function usePetLabel() {
  const { data } = useDocument<PetDefault>(SettingCollectionPath.PET, {
    listen: true,
  });

  return useMemo(() => {
    return {
      petLabel: getPetLabel(data),
      petDefaultSetting: data ?? undefined,
    };
  }, [data]);
}
